"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserIdentity = exports.IdentityProofDocument = void 0;
const validator_1 = require("@leavy/validator");
const ddd_1 = require("../../infrastructure/ddd");
const utils_1 = require("@leavy/utils");
const Address_1 = require("../../common/domain/Address");
class IdentityProofDocument extends ddd_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    toPlain() {
        return { ...this };
    }
}
exports.IdentityProofDocument = IdentityProofDocument;
class UserIdentity extends ddd_1.ValueObjectBase {
    constructor(data) {
        super();
        this.proof = [];
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.firstName) && utils_1.Guard.String.isNotEmpty(this.firstName)
            && utils_1.Guard.isNotNullish(this.lastName) && utils_1.Guard.String.isNotEmpty(this.lastName)
            && utils_1.Guard.isNotNullish(this.address)
            && utils_1.Guard.isNotNullish(this.birthDate)
            && utils_1.Guard.isNotNullish(this.cityOfBirth) && utils_1.Guard.String.isNotEmpty(this.cityOfBirth)
            && utils_1.Guard.isNotNullish(this.countryOfBirth) && utils_1.Guard.String.isNotEmpty(this.countryOfBirth)
            && utils_1.Guard.isNotNullish(this.nationality) && utils_1.Guard.String.isNotEmpty(this.nationality)
            && utils_1.Guard.isNotNullish(this.proof) && this.proof.length > 0);
    }
    toPlain() {
        return { ...this };
    }
}
__decorate([
    (0, validator_1.Type)(() => Address_1.Address),
    __metadata("design:type", Address_1.Address)
], UserIdentity.prototype, "address", void 0);
__decorate([
    (0, validator_1.Type)(() => IdentityProofDocument),
    __metadata("design:type", Array)
], UserIdentity.prototype, "proof", void 0);
exports.UserIdentity = UserIdentity;
//# sourceMappingURL=UserIdentity.js.map